module.exports = __webpack_public_path__ + "static/bg_image_trainings_page-502575472d8b4d2f4d5681a13aedca2d.jpg";